export default __webpack_public_path__ + "static/Live-Video_Kaspersky2017-d73baeb035911da6ce8e02792dd31927.webp";